import type { RouteObject } from "react-router-dom";

export const merchantSubmissionRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Merchant submissions" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { MerchantSubmissionsPage } =
            await import("./merchant-submissions-page");
          return { Component: MerchantSubmissionsPage };
        },
      },
    ],
  },
];
